import PageContainer from "@/common/components/PageContainer";
import { useLocalContext } from "@/setup/locale-provider";
import { Grid, Title } from "@mantine/core";
import { useRouter } from "next/dist/client/router";
import JobTable from "./JobTable";
import Method from "./Method";

export default function Career() {
  const { getLabel } = useLocalContext();
  const { locale } = useRouter();

  const titlePage = {
    vi: getLabel("Thông tin tuyển dụng"),
    en: getLabel("Employment information"),
  };

  return (
    <PageContainer>
      <Grid gutter={0}>
        <Grid.Col sm={12} lg={12}>
          <PageContainer>
            <Title order={4}>{titlePage[locale]}</Title>
            <JobTable />
          </PageContainer>
        </Grid.Col>
        {/* <Grid.Col sm={12} lg={3}>
          <Method />
        </Grid.Col> */}
      </Grid>
    </PageContainer>
  );
}
